import React from 'react';

function CityDetails() {
  return (
    <div className='container mt-3'>
      <div className='card'>
        <div className='card-body'>

          {/* City Info Section */}
          <div className='city-info-section mb-4'>
            <h4 className="card-title">City Info</h4>
            
            <ul className="list-group">
              <li className="list-group-item"><strong>City Name:</strong> Hosapete</li>
              <li className="list-group-item"><strong>Alias Name:</strong> Hospet, Hpt, Hosapete, Vijaynagar</li>
              <li className="list-group-item"><strong>Description:</strong> </li>
              <li className="list-group-item"><strong>Launch Date:</strong>10/01/2014 </li>
              <li className="list-group-item"><strong>Zone:</strong> 15.674, 75.678{/* Add latitude and longitude here */}</li>
            </ul>
          </div>

          {/* Assets Section */}
          <div className='assets-section mb-4'>
            <h4 className="card-title">Assets</h4>
            <ol className='list-group'>
                <li className='list-group-item'><strong>City Logo:</strong></li>
                <li className='list-group-item'><strong>Get Started Image:</strong></li>

            </ol>
            {/* <div className='d-flex'> */}
              {/* <img src="Logo image URL" alt="City Logo" className="img-fluid mr-2" /> */}
              {/* <img src="Get Started image URL" alt="Get Started" className="img-fluid" /> */}
            {/* </div> */}
          </div>

          {/* Pricing Section */}
          <div className='pricing-section mb-4'>
            <h4 className="card-title">Pricing</h4>
            <ul className="list-group">
              <li className="list-group-item"><strong>Minimum Charge:</strong> 30</li>
              <li className="list-group-item"><strong>Additional Charge:</strong> 10 </li>
              <li className="list-group-item"><strong>Additional Charge:</strong> 5</li>
            </ul>
          </div>

          {/* Restricted Zones Section */}
          <div className='restricted-zones-section'>
            <h4 className="card-title">Restricted Zones</h4>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Sl No.</th>
                  <th scope="col">Name</th>
                  <th scope="col">Coordinates</th>
                  <th scope="col">Description</th>
                  <th scope="col">City</th>
                  <th scope="col">ID</th>
                </tr>
              </thead>
              <tbody>
                {/* Add table rows dynamically */}
                <tr>
                  <td>1</td>
                  <td>Zone Name</td>
                  <td>Coordinates</td>
                  <td>Description</td>
                  <td>City</td>
                  <td>ID</td>
                </tr>
                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CityDetails;
